
<ng-template #loading class="loading-spinner">
  <div><mat-spinner diameter="50"></mat-spinner></div>
</ng-template>
<div
  class="filter-profile-settings"
  [ngClass]="{ 'read-only': isReadOnly }"
>
  <!-- WIP Dynamic Filter Settings LEAVE FOR FUTURE DEVELOPMENT -->
  <ng-container *ngIf="false">
    <div class="filter-profile">
      <div class="profile-grid">
        <div class="profile-row">
          <div class="label">{{ 'Filter Profile Name' | translate }}</div>
          <div class="value">
            <mat-form-field>
              <input matInput formControlName="filterProfileName" />
            </mat-form-field>
          </div>
        </div>
        <div class="profile-row">
          <div class="label">{{ 'Private' | translate }}</div>
          <div class="value">
            <mat-slide-toggle formControlName="isPrivate"></mat-slide-toggle>
          </div>
        </div>
        <div class="profile-row" *ngFor="let filter of filters">
          <div class="label">{{ formatFilterName(filter) | translate }}</div>
          <div class="value">
            <!-- set filter -->
            <ng-container *ngIf="filterModel[filter]?.filterType === 'set'">
              <mat-form-field>
                <mat-select multiple formControlName="filter">
                  <mat-option
                    *ngFor="let value of filterModel[filter]?.values.sort()"
                    [value]="value"
                  >
                    {{ value }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-container>

            <!-- date filter -->
            <ng-container *ngIf="filterModel[filter]?.filterType === 'date'">
              <mat-form-field>
                <mat-select formControlName="dateType">
                  <mat-option value="equals">Equals</mat-option>
                  <mat-option value="greaterThan">Greater than</mat-option>
                  <mat-option value="lessThan">Less than</mat-option>
                  <mat-option value="notEqual">Not equal</mat-option>
                  <mat-option value="inRange">In range</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field>
                <input matInput [matDatepicker]="picker" formControlName="dateFrom" />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
              <mat-form-field *ngIf="filterModel[filter]?.type === 'inRange'">
                <input matInput [matDatepicker]="pickerTo" formControlName="dateTo" />
                <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
                <mat-datepicker #pickerTo></mat-datepicker>
              </mat-form-field>
            </ng-container>

            <!-- text filter -->
            <ng-container *ngIf="filterModel[filter]?.filterType === 'text'">
              <mat-form-field>
                <mat-select formControlName="textType">
                  <mat-option value="contains">Contains</mat-option>
                  <mat-option value="notContains">Not contains</mat-option>
                  <mat-option value="equals">Equals</mat-option>
                  <mat-option value="notEqual">Not equal</mat-option>
                  <mat-option value="startsWith">Starts with</mat-option>
                  <mat-option value="endsWith">Ends with</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field>
                <input matInput formControlName="textFilter" />
              </mat-form-field>
            </ng-container>

            <!-- number filter -->
            <ng-container *ngIf="filterModel[filter]?.filterType === 'number'">
              <mat-form-field>
                <mat-select formControlName="numberType">
                  <mat-option value="equals">Equals</mat-option>
                  <mat-option value="notEqual">Not equal</mat-option>
                  <mat-option value="lessThan">Less than</mat-option>
                  <mat-option value="lessThanOrEqual">Less than or equals</mat-option>
                  <mat-option value="greaterThan">Greater than</mat-option>
                  <mat-option value="greaterThanOrEqual">Greater than or equals</mat-option>
                  <mat-option value="inRange">In range</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field>
                <input matInput type="number" formControlName="numberFilter" />
              </mat-form-field>
              <mat-form-field *ngIf="filterModel[filter]?.type === 'inRange'">
                <input matInput type="number" formControlName="numberFilterTo" />
              </mat-form-field>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

<div class="loading-indicator" *ngIf="isLoading$ | async">
  <mat-spinner diameter="50"></mat-spinner>
</div>
  
  <!-- Filter Profile Display -->
  <div class="form-container">
    <app-filter-profile-display
      [filterProfile]="filterProfile"
      [filterModel]="filterModel"
    ></app-filter-profile-display>
    <div class="profile-row form-fields">
      <div class="label">{{ 'General.Visibility' | translate }}</div>
      <div class="value">
        <app-form-field
          [formGroup]="filterForm"
          fieldControlName="isPrivate"
          [options]="[
            { value: 0, text: 'General.Public' | translate },
            { value: 1, text: 'General.Private' | translate }
          ]"
          type="ejs-dropdown"
          className="xs"
          col="12"
          [allowFiltering]="false"
        ></app-form-field>
      </div>
      <!-- Local validation error display -->
      <span class="control-error-container" *ngIf="!validationState.isPrivate.isValid && validationState.isPrivate.errorMessage">
        {{ validationState.isPrivate.errorMessage | translate }}
      </span>
    </div>
  </div>
</div>
